import React from 'react'
import styled from 'styled-components'
import { FlexCentered } from '~/components/common/containers'
import { BodyBold01 } from '~/components/common/typography'
import { Option } from './styled'

const Bar = styled.progress`
  appearance: none;
  border: 0;
  border-radius: 4px;
  background-color: ${({ theme }) => theme._neo.action01};
  flex-grow: 1;
  height: 6px;
  max-width: calc(100% - 70px);

  &::-moz-progress-bar {
    background-color: ${({ theme }) => theme._neo.ui01};
    border-radius: 3px;
    height: 8px;
  }

  &::-webkit-progress-bar {
    background-color: ${({ theme }) => theme._neo.ui01};
    border-radius: 3px;
    height: 8px;
  }

  &::-webkit-progress-value {
    background-color: ${({ theme }) => theme._neo.action01};
    border-radius: 3px;
  }
`

const Text = styled(BodyBold01)`
  margin-left: 8px;
  min-width: 80px;
  text-align: right;
`

const OptionWithBar = ({ children, percent, votes }) =>
  <>
    <Option>{children}</Option>
    <FlexCentered>
      <Bar max='100' value={percent} />
      <Text>{`(${votes}) ${percent}%`}</Text>
    </FlexCentered>
  </>

export default OptionWithBar
